// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_3IH2GictgxeSdR9JCgfpMv","cancelBtn":"_1v8STaK6JZA2vjVkYbDaoS","saveBtn":"_2qov3snsMmc941hCbuftLH"};